import { API_DELETE_MESSAGE, API_STAR_MESSAGE, API_INBOX_OUTBOX_MESSAGE_LIST, API_MESSAGE_GET_FORM, API_SEND_REPLY_MESSAGE, API_INBOX_OUTBOX_SEARCH, API_MESSAGE_MARK_AS_READ_UNREAD, API_SEARCH_PROVIDER, API_PATIENTGROUP_MESSAGE_MEMBERS } from 'api/endpoint';
import axios from 'axios';
import { param } from 'jquery';

/**
 * Get All Message Inbox 
 * @param data 
 * @author Shaheelnavas
 */

export const getInboxMessageList = (data) => {
    let apiURL = (data.searchParam && data.searchParam !== " ") ? API_INBOX_OUTBOX_SEARCH : API_INBOX_OUTBOX_MESSAGE_LIST
    return axios.post(apiURL, {
        action: 'INBOX',
        ...data,
    })
}
/**
 * Get All Message Outbox 
 * @param data
 * @author Shaheelnavas
 */
export const getOutBoxMessageList = (data) => {
    let apiURL = (data.searchParam && data.searchParam !== " ") ? API_INBOX_OUTBOX_SEARCH : API_INBOX_OUTBOX_MESSAGE_LIST
    return axios.post(apiURL, {
        action: 'SENT_ITEMS',
        ...data,
    })
}
export const getDraftMessageList = (data) => {
    let apiURL = (data.searchParam && data.searchParam !== " ") ? API_INBOX_OUTBOX_SEARCH : API_INBOX_OUTBOX_MESSAGE_LIST
    return axios.post(apiURL, {
        action: 'DRAFT',
        ...data,
    })
}
export const getStarredMessageList = (data) => {
    let apiURL = (data.searchParam && data.searchParam !== " ") ? API_INBOX_OUTBOX_SEARCH : API_INBOX_OUTBOX_MESSAGE_LIST
    return axios.post(apiURL, {
        action: 'STARRED',
        ...data,
    })
}
/**
 * Get All Patient Form Details 
 * @param data
 * @author Shaheelnavas
 */
export const getPatientForm = (data) => {
    let params = {
        typeId: 1,
        type: "MESSAGE",
        ...data
    }
    return axios.post(API_MESSAGE_GET_FORM, params)
}


export const sendReplyMessages = (data) => {
    return axios.post(API_SEND_REPLY_MESSAGE, data, {
        headers: {
            'content-type': 'multipart/form-data',
        },
    })
};

/** Midhila Velayudhan 
 * Date :30/09/2022
 * Bug #1009 implement status read/unread
 */
export const messageMarkAsReadUnread = (params) => {
    return axios.get(API_MESSAGE_MARK_AS_READ_UNREAD, { params });
}
/** Bug #1009 - @Author: Anupama P @Date 30Sep2022 */
export const deleteMessage = (params) => {
    return axios.get(API_DELETE_MESSAGE, { params })
};
/** Bug #1009 - @Author: Anupama P @Date 30Sep2022 */
export const starMessage = (params) => {
    return axios.get(API_STAR_MESSAGE, { params })
};

/**
 * Gett all Provider by portalAccount Id
 * @param portalAccountId 
 * @returns json
 */

export const searchProviderList = (portalAccountId) => {
    return axios.get(API_SEARCH_PROVIDER, {
        params: {
            portalAccountId: portalAccountId,
        }
    });
};
export const getPatientGroupMessageMemberList = (params) => {
    return axios.get(API_PATIENTGROUP_MESSAGE_MEMBERS, { params });
};
